<template>
    <div>
        <div class="flex flex-wrap items-center border-b mb-2 bg-gray-super-100">
            <div class="inline-block px-4 py-2 font-bold text-base"><i class="fas fa-list mr-2"></i></div>
            <div class="inline-block ml-auto pr-4">
                <span @click="handleAdd" class="btn btn-xs btn-blue btn-shadow-none"><i class="fas fa-plus"></i><b class="ml-1">Add a new Alert</b></span>
            </div>
        </div>

        <div v-for="(note, index) in notes" :class="{'border-t-0' : index > 0}" class="border p-2">
            <div class="flex flex-wrap mb-2">
                <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                    <label :for="`date-` + index">Date</label>
                    <div class="w-full">
                        <input :id="`date-` + index" type="date" class="form-input-inline-w-none w-auto" v-model="note.date">
                    </div>
                </div>

                <div class="xs:w-full w-1/2 pl-2 xs:pl-0 text-right">
                    <div @click="handleRemove(index)" class="btn btn-red btn-xs inline-block ml-auto">
                        <i class="fa fa-times cursor-pointer"></i>
                        Delete
                    </div>
                </div>
            </div>
            <div class="w-full mb-2">
                <label for="description">Description</label>
                <textarea id="description" class="form-input form-input-sm" rows="4" v-model="note.description"></textarea>
            </div>
            <div v-if="note.notification !== undefined" class="w-full mb-2">
                <label for="notification">
                    Send Notification
                    <input type="checkbox" name="notification" id="notification" class="ml-2" v-model="note.notification" />
                </label>
            </div>
        </div>
        <div class="w-full mt-8 flex">
            <div class="inline-block pr-4">
                <button class="btn btn-yellow" @click="handleSave">Save</button>
                <a href="/admin/jims-trade-tracker" class="text-black ml-2 btn btn-default">Cancel</a>
            </div>
            <div class="inline-block ml-auto">
                <span @click="handleAdd" class="btn btn-blue"><i class="fas fa-plus mr-1"></i>Add a new Alert</span>
            </div>
        </div>
        <flash-message ref="flash"></flash-message>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    initialNotes: {
        type: Array,
        required: true
    }
});

const flash = ref(null);
const notes = ref(props.initialNotes);

function handleRemove(index) {
    notes.value.splice(index, 1);
}

function handleAdd() {
    notes.value.push({
        notification: false
    });
}

function handleSave() {
    const route = window.route('admin.jims-trade-tracker.notes.update');
    axios.patch(route, { notes: notes.value })
        .then((response) => {
            flash.value.display('Successfully saved «Trade Tracker Notes»!');
        }).catch(error => {
            console.log(error);
            flash.value.error('Error saving «Trade Tracker Notes»');
        }).then(() => {
        });
}
</script>
